import { rgba } from '../utils/polished';
import tokens from './__generated__/tokens.json' assert { type: 'json' };

export const semantic = {
    content: {
        primary: tokens.colors.base.greys.tone900,
        secondary: tokens.colors.base.greys.tone600,
        error: tokens.colors.base.error.tone500,
        success: tokens.colors.base.success.tone500,
        information: tokens.colors.base.information.tone500,
        warning: tokens.colors.base.warning.tone500
    },
    background: {
        primary: tokens.colors.base.greys.tone000,
        secondary: tokens.colors.base.greys.tone100,
        loyalty: tokens.colors.laredoute.calmBlue.tone500,
        information: tokens.colors.base.information.tone100,
        warning: tokens.colors.base.warning.tone100,
        error: tokens.colors.base.error.tone100,
        success: tokens.colors.base.success.tone100
    },

    action: {
        background: {
            primary: {
                default: tokens.colors.base.greys.tone900,
                hover: tokens.colors.base.greys.tone800,
                active: tokens.colors.base.greys.tone600,
                disabled: rgba(tokens.colors.base.greys.tone900, 0.6),
                reversed: {
                    default: tokens.colors.base.greys.tone000,
                    hover: tokens.colors.base.greys.tone100,
                    active: tokens.colors.base.greys.tone300,
                    disabled: rgba(tokens.colors.base.greys.tone000, 0.6)
                }
            },
            secondary: {
                default: 'transparent',
                hover: rgba(tokens.colors.base.greys.tone900, 0.2),
                active: rgba(tokens.colors.base.greys.tone900, 0.6),
                disabled: 'transparent',
                reversed: {
                    default: 'transparent',
                    hover: rgba(tokens.colors.base.greys.tone000, 0.2),
                    active: rgba(tokens.colors.base.greys.tone000, 0.6),
                    disabled: 'transparent'
                }
            },
            tertiary: {
                default: rgba(tokens.colors.base.greys.tone900, 0.1),
                hover: rgba(tokens.colors.base.greys.tone900, 0.2),
                active: rgba(tokens.colors.base.greys.tone900, 0.6),
                disabled: rgba(tokens.colors.base.greys.tone900, 0.1),
                reversed: {
                    default: rgba(tokens.colors.base.greys.tone000, 0.2),
                    hover: rgba(tokens.colors.base.greys.tone000, 0.4),
                    active: rgba(tokens.colors.base.greys.tone000, 0.8),
                    disabled: rgba(tokens.colors.base.greys.tone000, 0.2)
                }
            }
        },
        content: {
            primary: {
                default: tokens.colors.base.greys.tone000,
                hover: tokens.colors.base.greys.tone000,
                active: tokens.colors.base.greys.tone000,
                disabled: tokens.colors.base.greys.tone000,
                reversed: {
                    default: tokens.colors.base.greys.tone900,
                    hover: tokens.colors.base.greys.tone900,
                    active: tokens.colors.base.greys.tone900,
                    disabled: tokens.colors.base.greys.tone900
                }
            },
            secondary: {
                default: tokens.colors.base.greys.tone900,
                hover: tokens.colors.base.greys.tone900,
                active: tokens.colors.base.greys.tone000,
                disabled: rgba(tokens.colors.base.greys.tone900, 0.6),
                reversed: {
                    default: tokens.colors.base.greys.tone000,
                    hover: tokens.colors.base.greys.tone000,
                    active: tokens.colors.base.greys.tone900,
                    disabled: rgba(tokens.colors.base.greys.tone000, 0.6)
                }
            },
            tertiary: {
                default: tokens.colors.base.greys.tone900,
                hover: tokens.colors.base.greys.tone900,
                active: tokens.colors.base.greys.tone000,
                disabled: rgba(tokens.colors.base.greys.tone900, 0.6),
                reversed: {
                    default: tokens.colors.base.greys.tone000,
                    hover: tokens.colors.base.greys.tone000,
                    active: tokens.colors.base.greys.tone900,
                    disabled: rgba(tokens.colors.base.greys.tone000, 0.6)
                }
            },
            link: {
                default: tokens.colors.base.greys.tone900,
                hover: tokens.colors.base.coral.tone500,
                active: tokens.colors.base.coral.tone600,
                disabled: tokens.colors.base.greys.tone500,
                reversed: {
                    default: tokens.colors.base.greys.tone000,
                    hover: tokens.colors.base.greys.tone900,
                    active: tokens.colors.base.greys.tone900,
                    disabled: tokens.colors.base.greys.tone500
                }
            }
        },
        border: {
            secondary: {
                default: tokens.colors.base.greys.tone900,
                hover: tokens.colors.base.greys.tone900,
                active: tokens.colors.base.greys.tone900,
                disabled: rgba(tokens.colors.base.greys.tone900, 0.6),
                reversed: {
                    default: tokens.colors.base.greys.tone000,
                    hover: tokens.colors.base.greys.tone000,
                    active: tokens.colors.base.greys.tone000,
                    disabled: rgba(tokens.colors.base.greys.tone000, 0.6)
                }
            }
        }
    },
    fields: {
        content: {
            default: tokens.colors.base.greys.tone900,
            disabled: tokens.colors.base.greys.tone700,
            hover: tokens.colors.base.greys.tone900,
            active: tokens.colors.base.greys.tone900,
            error: tokens.colors.base.error.tone900,
            success: tokens.colors.base.success.tone900
        },
        border: {
            default: tokens.colors.base.greys.tone400,
            disabled: tokens.colors.base.greys.tone500,
            hover: tokens.colors.base.greys.tone700,
            active: tokens.colors.base.greys.tone900,
            error: tokens.colors.base.error.tone500,
            success: tokens.colors.base.success.tone500
        },
        background: {
            disabled: tokens.colors.base.greys.tone100
        }
    },
    dimmer: {
        white: rgba(tokens.colors.base.greys.tone000, 0.85),
        black: rgba(tokens.colors.base.greys.tone900, 0.5)
    },
    focus: tokens.colors.base.information.tone500
};

export const colors = {
    ...tokens.colors,
    base: {
        ...tokens.colors.base,
        black: tokens.colors.base.greys.tone900,
        white: tokens.colors.base.greys.tone000
    },
    semantic
};
